<div class="main">
  <div class="d-flex flex-row">
    <div style="flex:1;font-size: 16px;">
      Please select 2 CBM partners in order of preference.
    </div>
    <div>
      <form action="" class="form-inline cbm-search-form">
        <div  class="custom-input-container">
          <input type="text"
            class="custom-input"
            maxlength="20"
            name="searchQuery"
            placeholder="Search CBM"
            [(ngModel)]="searchQuery"
            (keydown.enter)="applyFilter()">
            @if (searchQuery.length == 0 ) {
              <div
                class="search-button"
                (click)="applyFilter()">
              </div>
            }
            @if (searchQuery.length > 0 ) {
              <div
                class="clear-search-button"
                (click)="searchQuery = '' ; applyFilter() ">
              </div>
            }
            <div></div>
          </div>
        </form>
      </div>
    </div>
    <br>
      <div class="d-flex flex-row align-items-center">
        <div style="padding-right: 10px;">Filter By</div>
        <select-cbm-stars width='230px'
          [selectedIndex]="ratingIndex"
          (onSelectionChanged)="onRatingChanged($event)"
          (onIndexSelectionChanged)="ratingIndex = $event">
        </select-cbm-stars>
        <select-cbm-pcab width='230px'
          [selectedIndex]="pcabCategoryIndex"
          (onSelectionChanged)="onPcabChanged($event)"
          (onIndexSelectionChanged)="pcabCategoryIndex">
        </select-cbm-pcab>
        <button class="button button-active" (click)="applyFilter()">Apply Filter</button>
        <button class="button button-default" (click)="clearFilters()">Clear Filter</button>
      </div>
      <br>
        <div class="d-flex flex-row align-items-center cbm-header">
          <div style="flex: 3;">Contractor Name</div>
          <div style="flex: 2;">PCAB Category</div>
          <div style="flex: 1;">Star Rating</div>
        </div>
        <div class="d-flex flex-column cbm-list">
          @for (cbm of cbmList; track cbm; let i = $index) {
            <cbm-item
              (itemClick)="onCbmSelected(cbm['uuid'])"
              [selected]=" isSelected(cbm['uuid']) "
              [selectionOrder]="getSelectionOrder(cbm['uuid'])"
              (onViewDetail)="viewDetail(cbm['uuid'])"
              [name]="cbm['cbmName']"
              [tags]="cbm['tags']"
              [uuid]="cbm['uuid']"
              [rating]=" cbm.rating"
              [city]="city"
              [pcab]="cbm['pcabCategory']"
              [recommended]=" cbm.hasOwnProperty('recommended') "
              >
            </cbm-item>
          }
        </div>
        @if ( cbmList.length == 0 && !showProgress) {
          <div class="no-result">
            Sorry, no contractors found<br>Try searching again
          </div>
        }
        @if (showProgress) {
          <div class="d-flex flex-row align-items-center justify-content-center">
            <div class="loadingio-spinner-pulse-uq8kufhdmv">
              <div class="ldio-okxz8jkbhq">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        }
        <br>
          @if (showMore && cbmList.length >= 3) {
            <div class="show-more"
              (click)="onShowMore()">
              Show more Contractors
            </div>
          }
          @if (showPagination) {
            <pagination-admin
              [pageCount]="pageCount"
              [selectedPage]="page"
              [offset]="pageOffset"
              (onPageSelected)="showPage($event)">
            </pagination-admin>
          }
          <cbm-detail-modal
            [visible]="showDetailModal"
            (onDismiss)="showDetailModal = false;"
            (onSelect)="onCbmViewSelected($event)"
            [cbmID]="cbmViewId"
            [cbmData]="cbmViewData"
            (onViewAll)="viewCbmPage($event)">
          </cbm-detail-modal>
          <info-modal
            [visible]="modal_info"
            [title]="'Max Number of CBMs Selected'"
            [message]="'Only 2 CBM selection is allowed.\nDeselect your previous choice\nbefore selecting a new one.'"
            (onConfirm)="modal_info = false;">
          </info-modal>
        </div>
